export default "__VITE_PUBLIC_ASSET__4cc89dfa__"